import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { ContAffiliation, H5Styled } from '../../../styled-components';
import { CurrencyField, DataTable, Field } from '../../../commons/DataTable';

const VERTICALS = [
  'invoices',
  'partnerEon',
  'recurringFee',
  // 'insurance',
  'signal',
];

const METRICS = [
  { key: 'adminShareTot', title: 'Quota totale da ricevere' },
  {
    key: 'adminShareCollectedTot',
    title: 'Quota ricevuta',
  },
  {
    key: 'adminShareNotCollectedTot',
    title: 'Quota da ricevere',
  },
  // {
  //   key: 'adminShareIafPaidTot',
  //   title: 'Quota ricevuta',
  // },
  // {
  //   key: 'adminShareIafNotPaidTot',
  //   title: 'Quota da IAF emessi',
  // },
  // {
  //   key: 'adminShareExtraInvoicePaidTot',
  //   title: 'Quota da fattura extra emesse e incassate',
  // },
  // {
  //   key: 'adminShareExtraInvoiceNotPaidTot',
  //   title: 'Quota da fattura extra emesse e non incassate',
  // },
  // {
  //   key: 'adminShareExtraInvoiceNotEmittedTot',
  //   title: 'Quota da fattura extra non emesse',
  // },
  // {
  //   key: 'adminShareInvoiceNotPaidTot',
  //   title: 'Quota da fattura non pagate',
  // },
];

function GeneralTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  onShowInfo,
  onShowIafs,
  onShowFinancialReports,
  year,
}) {
  const [t] = useTranslation('GIVE_AND_TAKE');
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    const totals = METRICS.map(({ key, title }) => ({
      title,
      value: VERTICALS.reduce(
        (sum, vertical) => sum + Number(data?.[vertical]?.[key] || 0),
        0
      ),
    }));

    setFormattedData(totals);
  }, [data]);

  return (
    <ContAffiliation>
      <Row>
        <Col xs="12">
          <H5Styled>Totale generale</H5Styled>
        </Col>
      </Row>
      <DataTable
        data={formattedData}
        total={total}
        offset={offset}
        limit={limit}
        onFilter={onFilter}
        onRowClick={(_, index) => {
          if (index === 1) {
            onShowIafs();
            return;
          }

          if (index === 2) {
            onShowInfo();
            return;
          }

          if (index !== 0) return;

          if (onShowFinancialReports) {
            onShowFinancialReports();
            return;
          }

          window.open(
            `${window.location.origin}/#/my-financial-reports?year=${year}`,
            '_blank'
          );
        }}
        emptyText={t('COMMON:NO_DATA')}
        tableFixed
      >
        <Field
          title="Descrizione"
          source="title"
          className="txt-table-center"
        />
        <CurrencyField
          title="Quota"
          source="value"
          className="txt-table-right"
        />
      </DataTable>
    </ContAffiliation>
  );
}

export default GeneralTable;
